/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IGenericPopupViewProps } from './generic-popup';
import { Modal, ModalBody, ModalHeader } from '@msdyn365-commerce-modules/utilities';

const GenericPopupView: React.FC<IGenericPopupViewProps> = props => {
    const {
        slots,
        popupVisible,
        recallVisible,
        classNamePopup,
        classNameRecall,
        onDismissRecall,
        onDismissPopup,
        handleTextRecall
    } = props;
    const { modalId, recallDismissable, modalHeader, recallText } = props.config;
    const { closeButtonAriaLabel, closeButtonLabel } = props.resources;

    React.useEffect(() => {
        if (popupVisible) {
            //@ts-ignore
            const label = props.config.modalName || 'Generic';
            window.dataLayer?.push?.({
                event: 'gaEvent',
                eventCategory: 'popup',
                eventAction: 'displayed',
                eventLabel: label
            });
        }
    }, [popupVisible]);

    const handleClose = React.useCallback(() => {
        const popupElement = document.querySelector('.venchi_popup');
        const form = popupElement?.getElementsByTagName('form');

        if (form?.length && popupVisible) {
            const label = props.config.modalName;
            window.dataLayer?.push?.({
                event: 'gaEvent',
                eventCategory: 'popup',
                eventAction: 'click_close',
                eventLabel: label
            });
        }
        onDismissPopup();
    }, [onDismissPopup, popupVisible, props]);

    return (
        <>
            <Modal id={modalId} isOpen={popupVisible} onClosed={handleClose}>
                <ModalHeader toggle={handleClose}>{modalHeader}</ModalHeader>
                <div className={classNamePopup}>
                    <ModalBody>
                        <div {...props.renderModuleAttributes(props)} id={props.id}>
                            <div className='row'>{slots.content}</div>
                        </div>
                    </ModalBody>
                </div>
            </Modal>
            {recallVisible ? (
                <div className={classNameRecall}>
                    <button className='venchi-recall__text' onClick={handleTextRecall}>
                        <span>{recallText}</span>
                    </button>
                    {recallDismissable ? (
                        <button className='venchi-recall__close-button' aria-label={closeButtonAriaLabel} onClick={onDismissRecall}>
                            <span className='venchi-recall__close-button__label' aria-hidden='true'>
                                {closeButtonLabel}
                            </span>
                        </button>
                    ) : (
                        <></>
                    )}
                </div>
            ) : (
                <></>
            )}
        </>
    );
};

export default GenericPopupView;
